<template>
  <div class="content" style="margin-top: 20px">
    <h-input
      name="title"
      v-if="$attrs.schema.title"
      :model="model.title"
      :schema="$attrs.schema.title"
      @title-edited="title = $event"
      ref="title"
    ></h-input>
    <h-taginput
      name="license"
      v-if="$attrs.schema.license"
      :focusOnMount="false"
      :model="model.license"
      :schema="$attrs.schema.license"
      @license-edited="license = $event"
      ref="license"
    ></h-taginput>
    <h-taginput
      name="tags"
      v-if="$attrs.schema.tags"
      :focusOnMount="false"
      :model="model.tags"
      :schema="$attrs.schema.tags"
      @tags-edited="tags = $event"
      ref="tags"
    ></h-taginput>
    <h-input
      name="provider"
      v-if="$attrs.schema.provider"
      :model="model.provider[0]"
      :schema="$attrs.schema.provider"
      @provider-edited="provider = $event"
      ref="provider"
    ></h-input>
    <h-input
      name="description"
      v-if="$attrs.schema.description"
      :model="model.description"
      :schema="$attrs.schema.description"
      inputType="textarea"
      @description-edited="description = $event"
      ref="description"
    ></h-input>
  </div>
</template>

<script>
export default {
  data() {
    return {
      ...this.model,
    };
  },
  props: ["model"],
  watch: {
    //Triggered when new model is replaced
    model: {
      deep: true,
      handler(val) {
        Object.keys(val).forEach(m => {
          this[m] = val[m];
        });
      },
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/HLevel.scss";

.media > div {
  margin-left: 5px;
}
</style>
